<template>
  <div>
    <div class="page-card">
      <div class="section-head">
        <h2 class="page-title" style="margin-bottom: 0;">预览菜单</h2>
        <div class="menu-preview-actions">
          <el-button type="primary" :disabled="!record" @click="goEdit">修改</el-button>
          <el-button @click="goBack">返回</el-button>
        </div>
      </div>
      <p v-if="!record" class="preview-empty">未找到该历史菜单。</p>
      <div v-else class="preview-sheet">
        <div v-if="record.previewContent" class="pdf-preview-body">{{ record.previewContent }}</div>
        <template v-else>
          <div class="pdf-title">{{ record.title }}</div>
          <div v-for="(name, idx) in record.dishNames" :key="idx" class="pdf-dish">{{ name }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getMenuHistory } from '@/utils/menuHistory'
import { setPendingMenu } from '@/utils/pendingMenu'
import { historyFormFromRecord, resolveHistoryDishes } from '@/utils/historyDishes'

export default {
  name: 'MenuPreview',
  data() {
    return {
      record: null
    }
  },
  created() {
    this.loadRecord()
  },
  watch: {
    '$route.params.id'() {
      this.loadRecord()
    }
  },
  methods: {
    loadRecord() {
      this.record = getMenuHistory(this.$route.params.id)
    },
    goEdit() {
      if (!this.record) return
      const dishes = resolveHistoryDishes(this.record)
      const form = historyFormFromRecord(this.record)
      if (!dishes.length && !form) {
        this.$message.warning('该历史菜单没有可带入的信息')
        return
      }
      setPendingMenu(dishes, form)
      this.$router.push({ name: 'MenuGenerate' })
    },
    goBack() {
      this.$router.push({ name: 'HistoryMenus' })
    }
  }
}
</script>

<style scoped>
.preview-empty {
  color: #909399;
}

.preview-sheet {
  max-width: 560px;
  padding: 24px 8px;
}

.menu-preview-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
